import React from "react";
import { EditorState } from "braft-editor";
import { render } from '@testing-library/react';

export interface ToolListItem {
  key: any;
  color: string;
  iconClass: string;
  iconTextClass: string;
  onClick: any;
  text?: string;
  render?: (i: ToolListItem, innerIcon: any, innerText: any, divWrapStyle: React.CSSProperties | undefined) => any;
};
interface ControlsToolBarProps {
  editorState: EditorState;
  setEditorState: any;
  toolList: Array<ToolListItem>;
  injectIconWrapStyle?: any;
  injectIconStyle?: any;
  injectIconTextStyle?: any;
}

export const ControlsToolBar = (props: ControlsToolBarProps) => {
  const {
    editorState,
    setEditorState,
    toolList = [],
    injectIconWrapStyle = {},
    injectIconStyle = {},
    injectIconTextStyle = {},
  } = props;
  const IconWrapStyle = {
    display: 'flex',
    alignItems: 'center',
    cursor: "pointer",
    textAlign: "center" as const,
    minWidth: "42px",
    ...injectIconWrapStyle,
  };
  const IconStyle = { fontSize: "21px", ...injectIconStyle };
  const IconTextStyle = { margin: "0 4px", ...injectIconTextStyle };

  if (toolList.length < 1) {
    return null;
  }

  return (
    <>
    {
      toolList.map(i => {
        const innerIcon = <i className={i.iconClass} style={IconStyle} />;
        const innerText = i.text ? <span className={i.iconTextClass} style={IconTextStyle}>{i.text}</span> : null;
        const divWrapStyle = { color: i.color, ...IconWrapStyle };
        const wrapperDom = (
          <div
            key={`toolList_${i.key}`}
            style={divWrapStyle}
            onClick={i.onClick}
          >
            {innerIcon}
            {innerText}
          </div>
        );

        if (i.render) {
          return i.render(i, innerIcon, innerText, divWrapStyle);
        }

        return wrapperDom;
      })
    }
    </>
  );
};
